import {AppDispatch} from "../index"
import $api from "../../axios"
import {callSlice} from "../slices/callSlice"

export const getClientCallHistory = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(callSlice.actions.waiting())
    const response = await $api.get("request/request/get-client-call-history")

    if (response.status === 200) {
      dispatch(callSlice.actions.received(response.data))
    }
  } catch (e: any) {
    console.log(e)
  }
}

export const continueWaitingCall = () => (dispatch: AppDispatch) => {
  dispatch(callSlice.actions.continueWaiting())
}